"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiSupplierMerchantDto = void 0;
const swagger_1 = require("../../../../swagger-fake");
const class_validator_1 = require("class-validator");
const billing_api_supplier_extra_field_dto_1 = require("./billing-api-supplier-extra-field.dto");
const class_transformer_1 = require("class-transformer");
/**
 * Информация о связи поставщика с мерчантом
 */
let BillingApiSupplierMerchantDto = class BillingApiSupplierMerchantDto {};
__decorate([(0, swagger_1.ApiProperty)({
  description: "Дополнительные сведения о поставщике в формате ключ = значение, требуемые мерчантом.",
  type: () => billing_api_supplier_extra_field_dto_1.BillingApiSupplierExtraFieldDto,
  isArray: true
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsArray)(), (0, class_validator_1.ValidateNested)({
  each: true
}), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiSupplierMerchantDto.prototype, "supplier", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Сведения о счёте для выплат, требуемые мерчантом.",
  type: () => billing_api_supplier_extra_field_dto_1.BillingApiSupplierExtraFieldDto,
  isArray: true
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsArray)(), (0, class_validator_1.ValidateNested)({
  each: true
}), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiSupplierMerchantDto.prototype, "payoutAccount", void 0);
BillingApiSupplierMerchantDto = __decorate([(0, class_transformer_1.Exclude)()], BillingApiSupplierMerchantDto);
exports.BillingApiSupplierMerchantDto = BillingApiSupplierMerchantDto;
